/* eslint-disable import/extensions */
/* eslint-disable new-cap */

// eslint-disable-next-line import/no-extraneous-dependencies
import jsPDF from 'jspdf';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'jspdf-autotable';
// eslint-disable-next-line import/no-extraneous-dependencies
import ExcelJS from 'exceljs';
import { useModulePathname, useModuleNavigate } from '../../../layouts/main/ModuleNavigation';


export default function CommonButtons(pageName, filteredData, handleOpenFilter) {
    const modulePathname = useModulePathname();
    const navigate = useModuleNavigate();
    const downloadPDF = () => {
        if (!filteredData) return;

        const columns = filteredData.ColumnWidth.map(column => column.ColumnName);
        const rows = filteredData.Data.map(row =>
            columns.map(column => row[column])
        );

        // eslint-disable-next-line new-cap
        const doc = new jsPDF();
        doc.autoTable({
            head: [columns],
            body: rows,
        });


        // Create timestamp for filename
        const timeStamp = new Date().toISOString().replace(/[:\-T]/g, '').slice(0, 15);
        doc.save(`${pageName}_${timeStamp}.pdf`);
    };

    const downloadExcel = async () => {
        if (!filteredData) return;

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sheet1');

        // Set columns
        const columns = filteredData.ColumnWidth.map(column => ({
            header: column.ColumnName,
            key: column.ColumnName,
           // width: column.Width || 20
        }));
        worksheet.columns = columns;

        // Add data rows
        filteredData.Data.forEach((dataRow) => {
            const row = {};
            columns.forEach((col) => {
                row[col.key] = dataRow[col.key];
            });
            worksheet.addRow(row);
        });

        // Style header row
        worksheet.getRow(1).eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { vertical: 'center', horizontal: 'center' };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFC5D9F1' } };
        });


        // Style body rows
        worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
            if (rowNumber !== 1) {
                row.eachCell({ includeEmpty: true }, (cell) => {
                    cell.alignment = { vertical: 'center', horizontal: 'left', wrapText: true };
                    cell.border = {
                        top: { style: 'thin', },
                        left: { style: 'thin' },
                        bottom: { style: 'thin' },
                        right: { style: 'thin' },
                    };
                    
                });
            }
        });

        // **Auto-Fit Column Widths Based on Content**
        worksheet.columns.forEach((column) => {
            let maxLength = column.header.length; // Start with header length
            column.eachCell({ includeEmpty: true }, (cell) => {
                if (cell.value) {
                    const cellValue = cell.value.toString();
                    maxLength = Math.max(maxLength, cellValue.length);
                }
            });
            column.width = maxLength + 2; // Add padding for readability
        });

        // Create timestamp for filename
        const timeStamp = new Date().toISOString().replace(/[:\-T]/g, '').slice(0, 15);

        // Generate and download the Excel file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `${pageName}_${timeStamp}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const buttons = [
        {
            title: 'Filter',
            icon: 'mdi:filter',
            onClick: handleOpenFilter,
            sx: {
                boxShadow: 'inset 0 0 0 #b3b3b3, 0 5px 0 0 #b3b3b3, 0 10px 5px #999999 !important',
                padding: "6px",
                height: "32px",
                width: "35px",
                border: '0.1px solid #e0e0e0',
                margin: '0 -9px 0 16px'
            }
        },
        {
            title: 'Add',
            icon: 'ic:sharp-add',
            size: "small",
            onClick: () => { navigate(`${modulePathname}/add`); },
            sx: {
                color: "white",
                bgcolor: '#43b5a2',
                boxShadow: 'inset 0 0 0 #b3b3b3, 0 5px 0 0 #b3b3b3, 0 10px 5px #999999 !important',
                padding: "8px",
                height: "32px",
                width: "35px",
                margin: '0 -9px 0 16px'
            }
        },
        {
            title: 'Export To Excel',
            icon: 'vscode-icons:file-type-excel',
            onClick: downloadExcel,
            sx: {
                bgcolor: '#a6dbbc',
                color: '#fff',
                boxShadow: 'inset 0 0 0 #b3b3b3, 0 5px 0 0 #b3b3b3, 0 10px 5px #999999 !important',
                padding: "6px",
                height: "32px",
                width: "35px",
                margin: '0 -9px 0 16px'
            }
        },
        {
            title: 'Export To PDF',
            icon: 'icomoon-free:file-pdf',
            onClick: downloadPDF,
            sx: {
                bgcolor: '#ED5565',
                color: '#fff',
                boxShadow: 'inset 0 0 0 #b3b3b3, 0 5px 0 0 #b3b3b3, 0 10px 5px #999999 !important',
                padding: "8px",
                height: "32px",
                width: "35px",
                margin: '0 -12px 0 16px'
            }
        },
    ];

    return buttons;
}
